import { useEffect } from "react"
import "./App.css"
import "@radix-ui/themes/styles.css"
import { IonApp, IonRouterOutlet, setupIonicReact } from "@ionic/react"
import { IonReactRouter } from "@ionic/react-router"
import "@ionic/react/css/core.css"

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css"
import "@ionic/react/css/structure.css"
import "@ionic/react/css/typography.css"

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css"
import "@ionic/react/css/float-elements.css"
import "@ionic/react/css/text-alignment.css"
import "@ionic/react/css/text-transformation.css"
import "@ionic/react/css/flex-utils.css"
import "@ionic/react/css/display.css"

import "@fontsource/roboto/300.css"
import "@fontsource/roboto/400.css"
import "@fontsource/roboto/500.css"
import "@fontsource/roboto/700.css"

import { DrawingPage } from "./pages/DrawingPage"
import { Redirect, Route } from "react-router"
import { HomePage } from "./pages/HomePage"
import { TestSvg } from "./pages/TestSvg"
import { TestPage } from "./pages/TestPage"
import { DrawingViewer } from "./pages/DrawingViewer"
import { BlobViewer } from "./pages/BlobViewer"
import { SandboxPage } from "./pages/SandboxPage"
import { ExpressionInput } from "./pages/ExpressionInput"
import { Expr } from "../shared/Expr"
import { DrawingPageDebug } from "./pages/DrawingPageDebug"
import { SyncTest } from "./pages/SyncTest"
import { PricingPage } from "./pages/PricingPage"

setupIonicReact()

export function App() {
  return (
    <IonApp>
      <IonReactRouter>
        <IonRouterOutlet>
          <Route path="/home" component={HomePage} />
          <Route path="/drawing/:drawingId" component={DrawingPage} />
          <Route path="/blob/:key" component={BlobViewer} />
          <Route
            path="/viewer/:drawingId/page/:pageId"
            component={DrawingViewer}
          />

          <Route
            path="/drawing/:drawingId/debug"
            component={DrawingPageDebug}
          />

          <Route path="/sync_test" component={SyncTest} />

          <Route path="/svg" component={TestSvg} />

          <Route path="/test" component={TestPage} />
          <Route path="/expression" component={ExpressionShell} />

          <Route path="/sandbox" component={SandboxPage} />

          <Route path="/pricing" component={PricingPage} />

          <Redirect exact from="/" to="/home" />
        </IonRouterOutlet>
      </IonReactRouter>
    </IonApp>
  )
}

function ExpressionShell() {
  return <div></div>
  //return <ExpressionInput env={{ A1: Expr.lit(6), A2: Expr.lit(Date.now()) }} />
  // return (
  //   <ExpressionPage
  //     env={{
  //       "parameter-2": {
  //         name: "parameter-2",
  //         type: "number",
  //         defaultValue: 1,
  //       },
  //       "parameter-3": {
  //         name: "parameter-3",
  //         type: "number",
  //         defaultValue: 1,
  //       },
  //       "parameter-4": {
  //         name: "parameter-4",
  //         type: "number",
  //         defaultValue: 0,
  //       },
  //     }}
  //   />
  // )
}
